function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#ECFAD4",
  d: "M21.5 11c0 5.8-4.701 10.5-10.5 10.5C5.2 21.5.5 16.8.5 11S5.2.5 11 .5C16.799.5 21.5 5.2 21.5 11z"
}), React.createElement("path", {
  fill: "#9FDF58",
  d: "M11 1C5.477 1 1 5.477 1 11s4.477 10 10 10 10-4.477 10-10S16.523 1 11 1zM0 11C0 4.924 4.925 0 11 0s11 4.924 11 11c0 6.075-4.925 11-11 11S0 17.075 0 11z"
}), React.createElement("g", {
  transform: "translate(7.586 12.138)"
}, React.createElement("path", {
  fill: "#9FDF58",
  d: "M5.678 3.213a2.556 2.556 0 1 1-5.111-.001 2.556 2.556 0 0 1 5.111.001z"
})), React.createElement("g", {
  transform: "translate(5.31 6.069)"
}, React.createElement("path", {
  fill: "#9FDF58",
  d: "M3.52 2.227c0 .99-.643 1.792-1.436 1.792-.793 0-1.435-.803-1.435-1.792S1.29.437 2.084.437s1.436.801 1.436 1.79z"
})), React.createElement("g", {
  transform: "translate(12.138 6.069)"
}, React.createElement("path", {
  fill: "#9FDF58",
  d: "M3.333 2.227c0 .99-.643 1.792-1.436 1.792-.793 0-1.435-.803-1.435-1.792S1.104.437 1.897.437s1.436.801 1.436 1.79z"
})));

var SvgWow = function SvgWow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wow.618acb10.svg";
export { ForwardRef as ReactComponent };